module.exports = __webpack_public_path__ + "static/media/soleus_right_tension.6faedb10.png";